module.exports = __webpack_public_path__ + "img/como-funciona-relink-2.4f6fd2b.webp";